






























































































































































































































































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import SensitivityLabel from "@/components/SensitivityLabel.vue";
import LevelLabel from "@/components/LevelLabel.vue";
import { EventBus } from "@/eventbus";
import { CopyUrl } from "@/common/clipboard";
import { ref, computed } from "@vue/composition-api";
import { UseModal } from "@/components/root/modal";
import FileDetailsModalVue from "@/components/modals/FileDetailsModal.vue";
import EmptyCell from "@/components/EmptyCell.vue";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
    SensitivityLabel,
    LevelLabel,
    EmptyCell,
  },
  setup(props) {
    const showLoader = ref(false);

    const tableRow = ref(null);
    const onFilesClicked = () => {
      EventBus.emit("files", {
        item: props.source,
        // @ts-ignore
        rowEl: tableRow.value.$el,
      });
    };

    const onCountClick = () => {
      EventBus.emit("events", {
        item: props.source,
        // @ts-ignore
        rowEl: tableRow.value.$el,
      });
    };

    const showMenu = (event: MouseEvent) =>
      EventBus.emit("showMenu", { item: props.source, event });

    const toolipData = computed(() => {
      // @ts-ignore
      const { exposedPersonCount, someExposedToRefs } = props.source.details;
      const res = [
        "Exposed to",
        ...someExposedToRefs.map((d: any) => d.emailAddress),
      ];
      const diff = exposedPersonCount - someExposedToRefs.length;
      if (diff > 0) {
        res.push(`and ${diff} more...`);
      }
      return res;
    });

    const showConfidencePopup = (event: MouseEvent) => {
      EventBus.emit("confidence-popup", { source: props.source, event });
    };

    const showDetailsPopup = () => {
      UseModal().show(FileDetailsModalVue, props.source);
    };

    const showHistory = () => {
      EventBus.emit("showHistory", props.source);
    };

    return {
      showDetailsPopup,
      showLoader,
      showConfidencePopup,
      tableRow,
      onFilesClicked,
      onCountClick,
      CopyUrl,
      showMenu,
      toolipData,
      showHistory,
    };
  },
});
